import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    actionsContainer: {
      padding: '16px 20px',
    },
  };
});
